<template>
  <el-dialog
    title="新增标签"
    :visible.sync="addVisible"
    width="20%"
    top="30vh"
    :close-on-click-modal="false"
  >
    <p>标签为1-6个字符</p>
    <p>添加多个标签请用回车键隔开，每行一个</p>
    <el-input type="textarea" v-model="editTextarea" :autosize="true">
    </el-input>
    <p v-if="showError" class="error-tip">{{ errorCnt }}</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submitLabels">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listAddWikipediaLabel } from "@/service/wikipedia";
export default {
  name: "labelAdd",
  props: {
    callback: Function,
  },

  data() {
    return {
      addVisible: false,
      showError: false,
      errorCnt: "",
      editTextarea:'',
      tag_name:'',
    };
  },
  mounted() {},
  methods: {
    open() {
        this.addVisible=true;
    },
    /** 关闭右侧悬浮层 */
    handleClose() {
        this.editTextarea = null;
        this.errorCnt = null;
        this.showError = false;
        this.addVisible = false;
    },
    submitLabels() {
      //提交新增标签
      this.showError = false;
      var labelArr = this.editTextarea.split(/[(\r\n)\r\n]+/);
      if(labelArr[0].length<=0){
          this.errorCnt = "标签不能为空";
          this.showError = true;
          return null;
      }
      labelArr.forEach((el) => {
        if (el.length > 6) {
          this.errorCnt = "'" + el + "'超长，请修改";
          this.showError = true;
          return null;
        }
      });
      const index = labelArr.findIndex((v, v1) => {
        const k = labelArr.findIndex((a, a1) => {
          return a === v && a1 !== v1;
        });
        return k >= 0;
      });
      if (index >= 0) {
        this.errorCnt = "不能添加重复的标签，请修改";
        this.showError = true;
        return null;
      }
      if (this.showError) {
        return null;
      } else {
        this.tag_name = labelArr.join(",");

        listAddWikipediaLabel({ tag_name: this.tag_name })
          .then((data) => {
            this.$message({
              message: "添加成功",
              type: "success",
              duration: 3 * 1000,
            });
            this.handleClose();
            this.callback && this.callback()
          })
          .catch((err) => {
            const message = err.message;
            this.$message({
              message: message || "添加失败",
              type: "error",
              duration: 3 * 1000,
            });
          });
      }
    },
  },
};
</script>

<style scoped>
</style>
